licenseCriteriaPicker.$inject = ['licenseTypes']
export default function licenseCriteriaPicker(licenseTypes) {
  return {
    restrict: 'EA',
    scope: {
      product: '@',
      query: '='
    },
    template: require('./_licenseCriteriaPicker.html'),
    link: function(scope, elm, attrs) {
      scope.licenseTypes = licenseTypes
      scope.setActiveQueryAttr = function(attr, val) {
        scope.query[attr] = val
      }
    }
  }
}
